module.exports = __webpack_public_path__ + "img/customer.b1c296b2.jpeg";